<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-30 16:26:35
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-15 14:57:20
 * @FilePath: \jsczt_vue\src\components\myYear.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="my_select">
        <span class="icons"><img src="../assets/time.png" width="17PX" height="17PX"/></span>
        <el-select v-model="values" :popper-append-to-body="false" placeholder="请选择" @change="change" >
          <el-option
            v-for="item in options"
            :key="item.channelid"
            :label="item.chnldesc"
            :value="item.chnlname"
            style="padding-left: 10PX;"
          >
          </el-option>
        </el-select>
    </div>
    <div v-if="custom" class="yearChoose">
      <el-date-picker
        v-model="date"
        type="year"
        size="small"
        format="yyyy"
        value-format="yyyy"
        :picker-options="pickerOptions2"
      ></el-date-picker>
      -
      <el-date-picker
        v-model="date1"
        type="year"
        size="small"
        format="yyyy"
        value-format="yyyy"
        :picker-options="pickerOptions2"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myYear',
  props: {
    year: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pickerOptions2: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      options: [
        // {
        //   channelid: 1,
        //   chnldesc: '2012',
        //   chnlname: '2012'
        // }
      ],
      values: '',
      date: '',
      date1: '',
      custom: false,
      dateRange: '',
      pickerOptions: {
        // disabledDate (time) {
        //   return (
        //     time.getFullYear() < 2000 || time.getFullYear() > 2030
        //   )
        // }
      }
    }
  },
  watch: {
    year: {
      handler (val) {
        this.values = val
      },
      deep: true,
      immediate: true
    },
    date: {
      handler (val) {
        this.dateRange = val + ',' + this.date1
      },
      deep: true,
      immediate: true
    },
    date1: {
      handler (val) {
        this.dateRange = this.date + ',' + val
      },
      deep: true,
      immediate: true
    },
    dateRange: {
      handler (val) {
        this.$emit('dateRange', val)
      },
      deep: true,
      immediate: true
    }
  },
  async mounted () {
    this.values = this.year
    await this.getYear()
  },
  methods: {
    change (item) {
      this.$emit('change', item)
      if (item === '自定义') {
        this.custom = true
      } else {
        this.date = ''
        this.date1 = ''
        this.custom = false
      }
    },
    getYear () {
      this.$http.get('/api/wcmchannel/findYear').then(res => {
        this.options = res.data.data
        // this.options.forEach((item, index) => {
        //   if (item.chnlname === '2023') {
        //     this.options.splice(index, 1)
        //   }
        // })
        // 获取第一个值
        this.value = this.options[0].chnlname
        var customOption = {
          channelid: 0,
          chnldesc: '自定义',
          chnlname: '自定义'
        }
        this.options.push(customOption)
      })
    }
  }
}
</script>
<style scoped>
*{
  padding: 0;
  margin: 0;
}
a{
  text-decoration: none;
}
.my_select /deep/.el-input__inner {
  width: 166PX;
  height: 40PX;
  background: #fcfcfc;
  border: 1PX solid #4079ae;
  border-radius: 20PX;
  padding-left: 50PX;
}
.icons {
  position: absolute;
  top: 10PX;
  margin-left: 30PX;
  z-index: 9;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 166PX !important;
}
.yearChoose {
  margin-top: 10PX;
}
.yearChoose /deep/ .el-date-editor .el-input__inner {
  width: 166PX !important;
}
</style>



// WEBPACK FOOTER //
// src/components/myYear.vue